<form [formGroup]="dmrlFilterForm">
  <div class="form-content">
    <div class="pure-g">
      <div class="pure-u-md-24-24">
        <div class="pure-u-md-24-24 p-b-16 p-r-16">
          <app-aems-multiline-tag-input
            [heightInPixels]="200"
            label="Equipment Id(s)"
            formControlName="equipmentID"
            placeholder="Enter equipment id(s)"
            [regex]="equipmentNumberRegex"></app-aems-multiline-tag-input>
        </div>
        <!-- <div class="pure-u-md-12-24 p-b-16 p-r-16">
                    <app-aems-multiline-tag-input label="Location Code" formControlName="locationCode"
                        placeholder="Enter location code" [regex]="locationCodeRegex"></app-aems-multiline-tag-input>
                </div>
                 <div class="pure-u-md-12-24 p-b-16 p-r-16">
                    <app-aems-multiline-tag-input label="Profile" formControlName="profile"
                        placeholder="Enter Profile" [regex]="profileRegex"></app-aems-multiline-tag-input>
                </div>
                <div class="pure-u-md-12-24 p-b-16 p-r-16">
                    <mc-multi-select label="Production Year" fit="medium" width="100"
                        placeholder="Select Production Year" ngDefaultControl formControlName="productionYear">
                        @for (year of productionYears; track year) {
                          <mc-option [value]="year">
                              {{ year }}
                          </mc-option>
                        }
                    </mc-multi-select>

                </div>
                <div class="pure-u-md-12-24 p-b-16 p-r-16">

                    <mc-multi-select label="Equipment Group" fit="medium" width="100"
                        placeholder="Select Equipment Group" ngDefaultControl formControlName="equipmentGroup">
                        @for (equipmentGroup of equipmentGroupList; track equipmentGroup){
                        <mc-option [attr.data-cy]="equipmentGroup" [value]="equipmentGroup">{{
                            equipmentGroup.equipmentGroup }} </mc-option>
                        }
                    </mc-multi-select>

                </div>
                <div class="pure-u-md-12-24 p-b-16 p-r-16">

                    <mc-multi-select label="Equipment Owner" fit="medium" width="100"
                        placeholder="Select Equipment Owner" ngDefaultControl formControlName="equipmentOwner">
                        @for (equipmentOwner of equipmentOwnerList; track equipmentOwner){
                        <mc-option [attr.data-cy]="equipmentOwner" [value]="equipmentOwner">{{
                            equipmentOwner.equipmentOwner }} </mc-option>
                        }
                    </mc-multi-select>

                </div>
                <div class="pure-u-md-12-24 p-b-16 p-r-16">

                    <mc-multi-select label="Equipment Manufacturer" fit="medium" width="100"
                        placeholder="Select Equipment Manufacturer" ngDefaultControl
                        formControlName="equipmentManufacturer">
                        @for (equipmentManufacturer of equipmentManufacturerList; track equipmentManufacturer){
                        <mc-option [attr.data-cy]="equipmentManufacturer" [value]="equipmentManufacturer">{{
                            equipmentManufacturer.equipmentManufacturer }} </mc-option>
                        }
                    </mc-multi-select>

                </div>
                <div class="pure-u-md-12-24 p-b-16 p-r-16">

                    <mc-multi-select label="Equipment Reefer Type" fit="medium" width="100"
                        placeholder="Select Equipment Reefer Type" ngDefaultControl
                        formControlName="equipmentReeferType">
                        @for (equipmentReeferType of equipmentReeferTypeList; track equipmentReeferType){
                        <mc-option [attr.data-cy]="equipmentReeferType" [value]="equipmentReeferType">{{
                            equipmentReeferType.equipmentRefeerType }} </mc-option>
                        }
                    </mc-multi-select>

                </div>
                <div class="pure-u-md-12-24 p-b-16 p-r-16">

                    <mc-multi-select label="Container Type" fit="medium" width="100" placeholder="Select Container Type"
                        ngDefaultControl formControlName="containerType">
                        @for (containerType of containerTypeList; track containerType){
                        <mc-option [attr.data-cy]="containerType" [value]="containerType">{{
                            containerType.containerType }} </mc-option>
                        }
                    </mc-multi-select>

                </div>
                <div class="pure-u-md-8-24 p-b-16 p-r-16">
                    <mc-checkbox-group legend="Is Sales" style="display: grid;">
                        <div class="pure-g">
                            <mc-checkbox class="pure-u-md-6-24" [checked]="dmrlFilterForm.get('isSales')?.value=== true"
                                label="Yes" (change)="onSalesCheckChange(true)"></mc-checkbox>
                            <mc-checkbox class="pure-u-md-6-24"
                                [checked]="dmrlFilterForm.get('isSales')?.value=== false" label="No"
                                (change)="onSalesCheckChange(false)"></mc-checkbox>
                        </div>
                    </mc-checkbox-group>
                </div>
                <div class="pure-u-md-4-24 p-b-16 p-r-16">
                    <mc-checkbox-group legend="Is Surplus" style="display: grid;">
                        <div class="pure-g">
                            <mc-checkbox class="pure-u-md-12-24"
                                [checked]="dmrlFilterForm.get('isSurplus')?.value=== true" label="Yes"
                                (change)="onSurplusCheckChange(true)"></mc-checkbox>
                            <mc-checkbox class="pure-u-md-12-24"
                                [checked]="dmrlFilterForm.get('isSurplus')?.value=== false" label="No"
                                (change)="onSurplusCheckChange(false)"></mc-checkbox>
                        </div>
                    </mc-checkbox-group>
                </div>
                <div class="pure-u-md-12-24 p-b-16 p-r-16">
                    <mc-checkbox-group legend="Is Empty" style="display: grid;">
                        <div class="pure-g">
                            <mc-checkbox class="pure-u-md-4-24" [checked]="dmrlFilterForm.get('isEmpty')?.value=== true"
                                label="Yes" (change)="onEmptyCheckChange(true)"></mc-checkbox>
                            <mc-checkbox class="pure-u-md-4-24"
                                [checked]="dmrlFilterForm.get('isEmpty')?.value=== false" label="No"
                                (change)="onEmptyCheckChange(false)"></mc-checkbox>
                        </div>
                    </mc-checkbox-group>
                </div> -->
      </div>
    </div>
  </div>
  <div class="pure-u-md-24-24 utility-buttons">
    <mc-button
      label="Apply Filters"
      slot="primaryAction"
      variant="filled"
      appearance="primary"
      fit="medium"
      (click)="applyFilters()"
      class="p-r-16"></mc-button>
    <mc-button
      label="Clear Filters"
      slot="secondaryAction"
      appearance="neutral"
      fit="medium"
      (click)="clearFilters()"
      class="p-r-16"></mc-button>
  </div>
</form>
